import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { Promotion } from '../../../domain/qualification';
import { DataLoadState, ErrorType, initialDataLoadState } from '../../../store/reducers/common';

type PromotionState = {
  promotion?: Promotion;
} & DataLoadState;

const initialState: PromotionState = {
  ...initialDataLoadState,
};

const slice = createSlice({
  name: 'promotion',
  initialState,
  reducers: {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    getPromotion: (state, _action: PayloadAction<string>) => ({
      ...state,
      loading: true,
    }),
    getPromotionSuccess: (state, action: PayloadAction<Promotion>) => ({
      ...state,
      loading: false,
      promotion: action.payload,
    }),
    getPromotionFail: (state, { payload: { message } }: PayloadAction<ErrorType>) => ({
      ...state,
      loading: false,
      error: { message },
    }),
  },
});

export const promotionReducer = slice.reducer;
export const { getPromotion, getPromotionSuccess, getPromotionFail } = slice.actions;
